export function buildAdminMenuItems(vm) {
    return [
        {
            path: '/',
            exact: true,
            title: vm.trans('general.home'),
            perm: null,
            icon: 'home',
            group: 'overview',
        },
        {
            path: '/user',
            title: vm.trans('user.user'),
            perm: null,
            icon: 'users',
            group: 'management',
        },
        {
            path: '/currency',
            title: vm.trans('currency.currency'),
            perm: 'access-configuration',
            icon: 'rupee',
            group: 'management',
        },
        {
            path: '/plan',
            title: vm.trans('plan.plan'),
            perm: 'access-configuration',
            icon: 'layers',
            group: 'management',
        },
        {
            path: '/instance',
            title: vm.trans('instance.instance'),
            perm: 'access-configuration',
            icon: 'database',
            metric: 'instances',
            group: 'management',
        },
        {
            path: '/subscription',
            title: vm.trans('subscription.subscription'),
            perm: 'access-configuration',
            icon: 'receipt',
            group: 'management',
        },
        {
            path: '/subscriber',
            title: vm.trans('subscriber.subscriber'),
            perm: 'access-configuration',
            icon: 'mail',
            metric: 'subscribers',
            group: 'management',
        },
        {
            path: '/query',
            title: vm.trans('query.query'),
            perm: 'access-configuration',
            icon: 'chat',
            metric: 'queries',
            group: 'management',
        },
        {
            path: '/lead',
            title: vm.trans('lead.lead'),
            perm: 'list-lead',
            icon: 'user',
            group: 'management',
        },
        {
            path: '/blog',
            title: vm.trans('blog.blog'),
            perm: 'list-blog',
            icon: 'file',
            group: 'management',
        },
        {
            path: '/configuration',
            title: vm.trans('configuration.configuration'),
            perm: 'access-configuration',
            icon: 'settings',
            group: 'system',
        },
    ];
}

export const ADMIN_MENU_GROUP_ORDER = [
    { key: 'overview', label: 'Overview' },
    { key: 'management', label: 'Management' },
    { key: 'system', label: 'System' },
];

export function groupAdminMenuItems(items) {
    return ADMIN_MENU_GROUP_ORDER
        .map((group) => ({
            key: group.key,
            label: group.label,
            items: items.filter((item) => (item.group || 'management') === group.key),
        }))
        .filter((group) => group.items.length > 0);
}

export function isAdminNavActive(routePath, item) {
    if (item.exact || item.path === '/') {
        return routePath === '/' || routePath === '/home';
    }
    return routePath === item.path || routePath.startsWith(item.path + '/');
}
